import { render, staticRenderFns } from "./TablesList.vue?vue&type=template&id=4c10c5d9&scoped=true&"
import script from "./TablesList.vue?vue&type=script&lang=js&"
export * from "./TablesList.vue?vue&type=script&lang=js&"
import style0 from "./TablesList.vue?vue&type=style&index=0&id=4c10c5d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10c5d9",
  null
  
)

export default component.exports